import { useEffect, useState } from "react";
import { CircularProgress, Backdrop, Grid, Card, Typography, Box, Chip } from "@mui/material";
import * as c from '../../../../constants';
import { useAuth } from "../../../../provider";
import axios from "axios";
import SelectInputNew from "../../../../components/Forms/SelectInputNew";
import { Formik, Form } from 'formik';
//import BloodtypeIcon from "@mui/icons-material/Bloodtype";
import { useTheme } from "@mui/material";


export default function CalprotectinTest( result ) {

  const { state } = useAuth();
  const theme = useTheme();

  const isHigh = result === "high";

  // Base card style
  const baseCardStyles = {
    width: { xs: 380, sm: 400, md: 400, lg:800, xl: 1400 }, borderRadius: 3, position: 'relative', overflow: 'visible' }

  const cardStyles =
    theme.palette.mode === "light"
      ? {bgcolor: 'grey.C50', borderColor: 'grey.C900',}
      : 
      {bgcolor: 'greydark.C900', borderColor: 'greydark.C400', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', // Safari
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6)',};
 
   // selects all measurements of a user
   const url_dates = `${c.API_URL}/users/${state.user.id}/lab-visit-dates/`
   //const url_measure = `${c.API_URL}/measurements/${state.user.id}/`
 
   const [measurements, setMeasurements] = useState([]);
   const [dates, setDates] = useState([]);
   const [latestDate, setLatestDate] = useState(null);
 
   // MUST be declared before using it
   const [selectedDate, setSelectedDate] = useState(null);
 
   // Now safe to reference selectedDate
   const [localSelected, setLocalSelected] = useState(null);
 
   const [open, setOpen] = useState(false);
   const [initialLoading, setInitialLoading] = useState(true);

/// Fetch all unique dates from backend – RUN ONLY ONCE
  useEffect(() => {
    const fetchDates = async () => {
      try {
        const res = await axios.get(url_dates);
        const data = res.data;

        if (Array.isArray(data)) {
          const sortedDates = data
            .map((d) => d.date)
            .sort((a, b) => new Date(b) - new Date(a));   // newest first

          setDates(sortedDates);
          setLatestDate(sortedDates[0]);
          setSelectedDate(sortedDates[0]);   // AUTO-SELECT newest
          setLocalSelected(sortedDates[0]);
          setOpen(true);
        } else {
          console.error("API did not return an array:", data);
        }
      } catch (err) {
        console.error("Failed to fetch lab visit dates:", err);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchDates();
  }, []);  // IMPORTANT: no infinite loop

  const handleChange = (value) => {
    setLocalSelected(value);
    handleDateSelect(value);
  };

  // When selecting a date
  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setOpen(false);
  };

  return (
<>
<Grid container sx={{mb:4, display: "flex", justifyContent: "center", alignItems:'flex-start' }}>

    {/* FIRST API CALL SPINNER */}
      <Backdrop
        open={initialLoading}
        sx={{ color: "grey.C200", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

    {/* Select Labvisit Date */}
      <Grid size={12} sx={{mb:4, display: "flex", justifyContent: "center", alignItems:'flex-start' }}>
        <Box width={200}>
            <Formik initialValues={{ selectedDate: latestDate || "",}}>
                {({  }) => (
                <Form style={{ width: "100%" }}>
                    <SelectInputNew
                        name="selectedDate"
                        label="Select Labvisit Date"
                        options={dates.map(d => ({ label: d, value: d }))}
                    />
                </Form>
                )}
            </Formik>
          </Box>   
        </Grid>

    {/* MARKER CARDS */}
 {/* STOOL TEST CARDS */}
    <Grid size={12} sx={{display: "flex", justifyContent: "center", alignItems:'flex-start' }}>
                   <Card variant="outlined" sx={{ ...baseCardStyles, ...cardStyles }}>
                    <Grid container sx={{p:4}}>
  
                      <Grid size={12}>
                      {/* Marker Name, Short Description, */}   
                        <Typography variant="h4" fontWeight="400" gutterBottom={false} sx={{lineHeight: 1, mb:1}}>
                          CALPROTECTIN TEST
                        </Typography>
                        <Typography variant="subtitle2" fontWeight="400"  sx={{lineHeight:2}}>
                          Measures Calprotectin levels (protein) in a stool sample
                        </Typography>
                      </Grid>
                      </Grid> 


                    <Grid container sx={{px:4}}>
                      <Grid size={12}  sx={{mb:2, display:'flex',justifyContent:'center', alignItems:'flex-start'}}> 
                          <Typography variant="h4" fontWeight={400}>
                          Result:
                          </Typography>
                      </Grid> 

                       <Grid size={12}  sx={{mb:4, display:'flex',justifyContent:'center', alignItems:'flex-start'}}> 
                    <Chip
                    label={isHigh ? "HIGH" : "NORMAL"}
                    color={isHigh ? "error" : "success"}
                    sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: "1rem", letterSpacing: "0.09rem", mt: 1, px:1 }}
                    />
                    
                   </Grid> 


                    <Grid size={12}  sx={{ display:'flex',justifyContent:'flex-start', alignItems:'flex-start'}}> 
                    {/* Test Explanation */}
                        <Box mb={3}>
                        <Typography variant="h6" fontWeight={400} gutterBottom>
                        What is this test?
                        </Typography>
                        <Typography variant="subtitle2" sx={{fontWeight: 400}}> 
                        A calprotectin stool test measures a protein called calprotectin in a sample of your stool (poop). 
                        The test is also called a fecal calprotectin test. It's used to check for inflammation (swelling and irritation) in your intestines.<br /><br />

                        It's normal to have a small amount of calprotectin in your stool. But high levels are a sign that your intestines are inflamed. 
                        When you have inflammation in your intestines, your immune system sends certain types of white blood cells (neutrophils) to the inflamed area. 
                        These white blood cells release calprotectin into your intestines where it mixes with your stool.
                        </Typography>
                        </Box>
                     </Grid> 

                    <Grid size={12}  sx={{mb:4,  display:'flex',justifyContent:'flex-start', alignItems:'flex-start'}}> 
                    {/* Interpretation */}
                        <Box>
                        <Typography variant="h6" fontWeight={400} gutterBottom>
                        What your result means
                        </Typography>


                        {isHigh ? (
                        <Typography variant="subtitle2" sx={{fontWeight: 400}}> 
                        High levels of calprotectin usually mean that your intestines are inflamed. 
                        The higher the amount of calprotectin in your stool, the more inflammation you have. 
                        If your calprotectin levels are high, your provider may retest you in a few weeks to see if they change.
                        </Typography>
                        ) : (
                        <Typography variant="subtitle2" sx={{fontWeight: 400}}> 
                        Normal or low levels of calprotectin usually mean that your intestines are not inflamed, which means you don't have inflammatory bowel disease (IBD). 
                        Your symptoms are probably caused by a type of non-inflammatory condition. 
                        Your provider may order other tests to figure out which condition is causing your symptoms.
                        </Typography>
                        )}
                        </Box>
                   </Grid> 
                   
              </Grid> 
            </Card>
  </Grid>

  </Grid>
 
</>
);
}
